"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontFaces = void 0;
const styled_components_1 = require("styled-components");
const URL = 'https://static.vente-privee.com/vp5/fonts/';
const fontFaceFull = (family, path, weight, style, svg = 'vp_sansregular') => (0, styled_components_1.css) `
  @font-face {
    font-family: ${family};
    src: url(${URL}${path}.eot);
    src:
      url(${URL}${path}.eot?#iefix) format('embedded-opentype'),
      url(${URL}${path}.woff) format('woff'),
      url(${URL}${path}.ttf) format('truetype'),
      url(${URL}${path}.svg?#${svg}) format('svg'),
      url(${URL}${path}.woff2) format('woff2'),
      url(${URL}${path}.otf) format('opentype');
    font-weight: ${weight};
    font-style: ${style};
  }
`;
const getFontFaces = (fontFace) => (0, styled_components_1.createGlobalStyle) `
  /* VP Next */
  ${fontFace('VP Next', 'vpNext/VPSansNext-Regular', '400', 'normal')}
  ${fontFace('VP Next', 'vpNext/VPSansNext-Italic', '400', 'italic')}
  ${fontFace('VP Next', 'vpNext/VPSansNext-Medium', '500', 'normal')}
  ${fontFace('VP Next', 'vpNext/VPSansNext-MediumItalic', '500', 'italic')}
  ${fontFace('VP Next', 'vpNext/VPSansNext-Bold', '700', 'normal')}
  ${fontFace('VP Next', 'vpNext/VPSansNext-BoldItalic', '700', 'italic')}

  /* HK Grotesk */
  ${fontFace('HK Grotesk', 'hkGrotesk/HKGrotesk-Regular', '400', 'normal')}
  ${fontFace('HK Grotesk', 'hkGrotesk/HKGrotesk-Italic', '400', 'italic')}
  ${fontFace('HK Grotesk', 'hkGrotesk/HKGrotesk-Medium', '500', 'normal')}
  ${fontFace('HK Grotesk', 'hkGrotesk/HKGrotesk-MediumItalic', '500', 'italic')}
  ${fontFace('HK Grotesk', 'hkGrotesk/HKGrotesk-SemiBold', '600', 'normal')}
  ${fontFace('HK Grotesk', 'hkGrotesk/HKGrotesk-SemiBoldItalic', '600', 'italic')}
  ${fontFace('HK Grotesk', 'hkGrotesk/HKGrotesk-Bold', '700', 'normal')}
  ${fontFace('HK Grotesk', 'hkGrotesk/HKGrotesk-BoldItalic', '700', 'italic')}

  /* VP Condensed Next */
  ${fontFace('VP Condensed Next', 'vpCondensedNext/VPCondensedNext-Regular', '400', 'normal')}
  ${fontFace('VP Condensed Next', 'vpCondensedNext/VPCondensedNext-Bold', '600', 'normal', 'vp_condbold')}
  ${fontFace('VP Condensed Next', 'vpCondensedNext/VPCondensedNext-Light', '300', 'normal', 'vp_condlight')}

  /* Marianne */
  ${fontFace('Marianne', 'marianne/Marianne-Bold', '600', 'normal')}
  ${fontFace('Marianne', 'marianne/Marianne-ExtraBold', '700', 'normal')}
`;
exports.getFontFaces = getFontFaces;
const Fonts = (0, exports.getFontFaces)(fontFaceFull);
exports.default = Fonts;
